import { navigateToHeydayPage, subscribeToHeydayLocation } from '../../config/heydayRoutes';
import type { HeydayPage } from '../../config/heydayPageManifest';
import { gettingStartedItemIds, validGettingStartedDate, type GettingStartedDestination, type GettingStartedItemId, type GettingStartedLocation, type GettingStartedRoutePort } from '../../features/tenant-settings/public';

const destinations: Record<GettingStartedDestination, { page: HeydayPage; search?: string }> = {
  company: { page: 'admin-company-info' },
  'employee-number': { page: 'admin-reference-data', search: 'view=employee-number' },
  locations: { page: 'admin-reference-data', search: 'view=locations' },
  'job-profiles': { page: 'admin-reference-data', search: 'view=job-profiles' },
  'job-types': { page: 'admin-reference-data', search: 'view=job-types' },
  organizations: { page: 'organization' }, people: { page: 'people' },
  administrators: { page: 'admin-security' }, 'approval-settings': { page: 'workflow' },
  'absence-types': { page: 'absence-settings', search: 'view=types' },
  'absence-setup': { page: 'absence-settings', search: 'view=setup' },
  'absence-plans': { page: 'absence-settings', search: 'view=types' },
  'absence-calendars': { page: 'absence-settings', search: 'view=calendars' },
  'absence-operations': { page: 'absence' },
  'absence-approval-settings': { page: 'workflow' },
};

function locationFromValues(asOf: unknown, item: unknown): GettingStartedLocation {
  return {
    asOf: typeof asOf === 'string' && validGettingStartedDate(asOf) ? asOf : undefined,
    item: typeof item === 'string' && gettingStartedItemIds.includes(item as GettingStartedItemId) ? item as GettingStartedItemId : undefined,
  };
}

export const gettingStartedRouteAdapter: GettingStartedRoutePort & { availableDestinations(pages: ReadonlySet<HeydayPage>): GettingStartedDestination[] } = {
  availableDestinations(pages) {
    return (Object.keys(destinations) as GettingStartedDestination[]).filter((destination) => pages.has(destinations[destination].page));
  },
  read() {
    const search = new URLSearchParams(window.location.search);
    return locationFromValues(search.get('asOf'), search.get('item'));
  },
  setAsOf(asOf) {
    if (!validGettingStartedDate(asOf)) return;
    navigateToHeydayPage('admin-getting-started', new URLSearchParams({ asOf }));
  },
  open(destination, location) {
    const target = destinations[destination];
    const { asOf, item } = locationFromValues(location.asOf, location.item);
    if (asOf && item) {
      // Preserve the guide context in its own URL for browser Back navigation.
      navigateToHeydayPage('admin-getting-started', new URLSearchParams({ asOf, item }), { replace: true });
    }
    navigateToHeydayPage(target.page, target.search);
  },
  subscribe: subscribeToHeydayLocation,
};
